import * as React from "react";
import { Typography } from "antd";
import SearchInput from "./SearchInput/SearchInput.jsx";
import styles from "./index.module.less";
import { FormattedMessage } from "react-intl";
import { lang } from "../../api/config";
import banner from "../../assets/banner.png";
const { Title, Paragraph } = Typography;

export default function ImgContainer({
  onChangeKeyword,
  onChangeFlag,
  onChangeSelectedIndustry,
}) {
  const handleHomeClick = () => {
    const currentDomain = window.location.origin;
    window.location.href = currentDomain;
  };

  return (
    <div
      className={styles.top_banner}
      // style={{
      //   backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)), url(${banner})`,
      // }}
    >
      {/* <Breadcrumb
        style={{
          borderBottom: "1px solid #f0f0f0",
        }}
        items={[
          {
            title: (
              <span
                onClick={handleHomeClick}
                style={{ cursor: "pointer" }} // Add pointer cursor style
              >
                <FormattedMessage id="home" />
              </span>
            ),
          },
          {
            title: <FormattedMessage id="zhichi" />,
          },
          {
            title: <FormattedMessage id="ziyuan" />,
          },
        ]}
      /> */}
      <div className={styles.titleRow}>
        <Title className={lang === "en" ? styles.titleEn : styles.title}>
          <FormattedMessage id="ziyuan" />
        </Title>
        <Paragraph className={lang === "en" ? styles.descriptionEn : styles.description}>
          <FormattedMessage id="more" />
        </Paragraph>
      </div>
      <SearchInput
        onChangeKeyword={onChangeKeyword}
        onChangeFlag={onChangeFlag}
        onChangeSelectedIndustry={onChangeSelectedIndustry}
      />
    </div>
  );
}
